import axios from 'axios';

const BASE_URL = process.env.REACT_APP_BASE_URL;

export function getMyReferralsService() {
  return axios.get(`${BASE_URL}/referral/myReferrals`).then(({ data }) => data);
}

export function sendReferralService(emailTo) {
  return axios
    .post(`${BASE_URL}/referral/referFriend`, { emailTo })
    .then(({ data }) => data);
}
